import { createFeatureSelector, createSelector } from '@ngrx/store';

import * as fromStaticDataReducer from '../reducers';
import * as staticDataCountriesReducer from '../reducers/index';
import * as staticDataReducer from '../static-data.reducer';

//#region Static Data ROOT STATE
export const getAuthState = createFeatureSelector<staticDataReducer.State, staticDataReducer.StaticDataState>(
  staticDataReducer.staticDataFeatureKey
);
//#endregion

export const getStaticDataProductTypesState = createSelector(
  getAuthState,
  state => state[fromStaticDataReducer.fromStaticDataProductTypeReducer.productTypesFeatureKey]
);

export const getStaticDataProductTypesFailure = createSelector(
  getStaticDataProductTypesState,
  staticDataCountriesReducer.fromStaticDataProductTypeReducer.getProductTypesFailure
);

export const getStaticDataProductTypesResponse = createSelector(
  getStaticDataProductTypesState,
  staticDataCountriesReducer.fromStaticDataProductTypeReducer.getProductTypesResponse
);

export const getStaticDataProductTypesisLoaded = createSelector(
  getStaticDataProductTypesState,
  staticDataCountriesReducer.fromStaticDataProductTypeReducer.getProductTypesIsLoaded
);
